export class Todo {
    constructor(public text: string, public type: string, public isChecked: boolean) {}
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/shared/todo/index.ts